<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>Controles de zonas
                    <v-spacer></v-spacer>
                    <v-dialog
                            ref="dialog"
                            v-model="modal"
                            :return-value.sync="date"
                            persistent
                            width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="date"
                                    label="Fecha inicio"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="date" scrollable locale="es-co">
                            <v-spacer/>
                            <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                        </v-date-picker>

                    </v-dialog>

                    <v-dialog
                      ref="dialogfin"
                      v-model="modal_date_end"
                      :return-value.sync="date_end"
                      persistent
                      width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="date_end"
                          label="Fecha final"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                      />
                    </template>
                    <v-date-picker v-model="date_end" scrollable locale="es-co">
                      <v-spacer/>
                      <v-btn text color="primary" @click="modal_date_end = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogfin.save(date_end)">OK</v-btn>
                    </v-date-picker>

                  </v-dialog>
                    <v-select class="mx-2"
                              prepend-icon="fa-user"
                              label="Seleccione un usuario"
                              v-model="user"
                              :items="users"
                              item-text="first_name"
                              item-value="id"
                    />
                    <v-btn class="mr-2" color="primary" :loading="cargando" :disabled="cargando" @click="getControls()">Obtener</v-btn>
                  <download-excel
                      v-if="controls.length > 0"
                      class="v-btn v-btn--contained theme--light v-size--default success"
                      :data="controls"
                      :fields="json_fields"
                      worksheet="Controles"
                      :name="`controles_${$moment().format('YYYY-MM-DD')}.xls`"

                  >
                    Exportar excel
                  </download-excel>
                </v-card-title>
                <!-- Antes no habia ningun aviso: si faltaba la fecha o el usuario, el
                     boton no hacia nada visible (o tiraba un error en la consola). -->
                <v-alert v-if="errorMsg" :key="errorMsg" :type="errorTipo" dense dismissible class="mx-4">{{ errorMsg }}</v-alert>
                <v-card>
                    <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                        <v-timeline-item v-for="(item, index) in controls" :key="index">
                            <v-card>
                                <v-card-title class="blue darken-1 justify-center ">{{ item.createdAt.toDate() | moment("dddd, MMMM Do YYYY, h:mm:ss a")}}</v-card-title>

                                <v-list dense>
                                   <ListItem icon="fa-user"  :title="item.user.first_name+ ' ' + item.user.last_name"></ListItem>
                                    <ListItem icon="business" :title="item.zona.area"></ListItem>
                                    <ListItem icon="fa-map-marker" :title="item.zona.name"></ListItem>
                                </v-list>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>
                </v-card>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import {db} from "@/plugins/db";
    import {mapState} from "vuex";
    import ListItem from "../components/ListItem"

    export default {
        name: "Control",
        data(){
            return{
                modal:false,
                modal_date_end:false,
                date:'',
                date_end:'',
                controls:[],
                user: null,
                cargando: false,
                errorMsg: '',
                errorTipo: 'info',
                json_fields: {
                "Nombre de zona": "zona.name",
                 Area: "zona.area",
                "Fecha": {
                  field: "createdAt",
                  callback: (value) => {
                    return `${this.$moment(value.toDate()).format()}`;
                  },
                },
                "Nombre empleado": {
                  field: "user",
                  callback: (value) => {
                    return `${value.first_name} ${value.last_name}`;
                  },
                },
                "Rol del empleado": "user.role",
                "Tipo de empleado": "user.type",

              },
            }
        },
        components:{
            ListItem
        },
        methods:{
            /*
             * Antes esto tiraba `RangeError: Invalid time value` apenas se apretaba
             * "Obtener" sin elegir fecha: `this.date` arranca en '', `$moment('')` es
             * un momento invalido, `.format()` devuelve el texto "Invalid date" y
             * `new Date("Invalid date")` da un Date invalido que el SDK de Firestore
             * intenta convertir con `toISOString()`. El error quedaba en la consola y
             * el usuario solo veia que el boton no hacia nada.
             */
            async getControls(){
                this.controls = [];
                this.errorMsg = '';

                if (!this.$moment(this.date, 'YYYY-MM-DD', true).isValid()) {
                    this.errorTipo = 'info';
                    this.errorMsg = 'Elegi una fecha inicial.';
                    return;
                }
                if (!this.user) {
                    this.errorTipo = 'info';
                    this.errorMsg = 'Elegi un usuario.';
                    return;
                }

                const desde = this.$moment(this.date).startOf('day');
                // Sin fecha final se consulta un solo dia. El extremo superior es
                // exclusivo para que la medianoche no caiga en los dos dias.
                const hastaBase = this.$moment(this.date_end, 'YYYY-MM-DD', true).isValid()
                    ? this.$moment(this.date_end)
                    : this.$moment(this.date);
                const hasta = hastaBase.clone().add(1, 'days').startOf('day');

                if (hasta.isSameOrBefore(desde)) {
                    this.errorTipo = 'warning';
                    this.errorMsg = 'La fecha final no puede ser anterior a la inicial.';
                    return;
                }

                this.cargando = true;
                try {
                    const control = await db.collection('controls')
                        .where('user.id', '==', this.user)
                        .where('createdAt', '>=', desde.toDate())
                        .where('createdAt', '<', hasta.toDate())
                        .orderBy('createdAt', 'desc')
                        .get();

                    control.forEach(e => this.controls.push(e.data()));

                    if (this.controls.length === 0) {
                        this.errorTipo = 'info';
                        this.errorMsg = 'No hay controles registrados para ese usuario en esas fechas.';
                    }
                } catch (error) {
                    this.errorTipo = 'error';
                    this.errorMsg = 'No se pudieron cargar los controles. Revisa la conexion e intenta de nuevo.';
                } finally {
                    this.cargando = false;
                }
            }
        },
        computed:{
            ...mapState({
                users:state =>state.user.users
            })
        }
    }
</script>

<style scoped>

</style>
